export type RegisterPrefill = {
  email: string;
  firstName?: string | undefined;
  lastName?: string | undefined;
  salutation?: string | undefined;
};

/** Adds the Keycloak registration form prefill parameters to a registration url. */
export function buildRegisterUrlWithPrefill(
  registerUrl: string,
  prefill: RegisterPrefill | undefined
): string {
  const url = new URL(registerUrl);
  if (prefill) {
    const params = {
      email: prefill.email,
      firstName: prefill.firstName,
      lastName: prefill.lastName,
      "user.attributes.salutation": prefill.salutation,
    };
    for (const [name, value] of Object.entries(params)) {
      if (value) url.searchParams.set(name, value);
    }
  }
  return url.toString();
}
